
console.log('collectionfile')
sb_store_id = edd_store_id = sb_edd_options.store_id
shopnamefull = Shopify.shop;
if (shopnamefull == 'call-for-demo.myshopify.com') {
    edd_store_id = sb_store_id = 14000;
}
var add_ETA_on_collection_page = 0;
if (is_EnterPrise_client == 0 && sb_is_rule_set_for_location == 0 && sb_is_rule_set_for_zipcode == 0 && sb_is_rule_set_for_shipping == 0) {
    add_ETA_on_collection_page = 1;
}
var loadScriptForCartUpdate = function (url, callback) {
    var script = document.createElement("script");
    script.type = "text/javascript";
    if (script.readyState) { script.onreadystatechange = function () { if (script.readyState == "loaded" || script.readyState == "complete") { script.onreadystatechange = null; callback(); } }; } else { script.onload = function () { callback(); }; } script.src = url; document.getElementsByTagName("head")[0].appendChild(script);
};
if (typeof jQuery === "undefined" || parseFloat(jQuery.fn.jquery) < 1.7) {
    loadScriptForCartUpdate(
        "//ajax.googleapis.com/ajax/libs/jquery/1.9.1/jquery.min.js",
        function () {
            jQuery191 = jQuery.noConflict(true);
            CallCollectionETAMain(jQuery191)
        }
    );
} else {
    CallCollectionETAMain($)
}
function CallCollectionETAMain($) {

    var cfpCollectionLabelClass = 'cfp-checked';
    
    app_enable = sb_edd_options.is_enabled

    collection_page_eta_enable = 0;
    collection_eta_message = 'not_set';
    if (typeof sb_edd_options.collection_page_eta_enable != 'undefined') {
        translation_obj = 'not_set';
        collection_page_eta_enable = sb_edd_options.collection_page_eta_enable
        collection_eta_message = sb_edd_options.collection_eta_message
        if (typeof sb_edd_options.translated_wrods != 'undefined') {
            translated_wrods = JSON.parse(sb_edd_options.translated_wrods)
            for (var p = 0; p < translated_wrods.length; p++) {
                check_lan_obj = translated_wrods[p]
                $.each(check_lan_obj, function (key, value) {
                    if (key == Shopify.locale) {
                        translation_obj = value
                    }
                    if (key == 'all_language') {
                        translation_obj_for_all_language = value
                    }

                })
            }

            if (typeof translation_obj != 'undefined') {
                if (translation_obj == 'not_set' && translation_obj_for_all_language != 'not_set') {
                    translation_obj = translation_obj_for_all_language
                }
                if (translation_obj != 'not_set' && typeof translation_obj.trans_collection_eta_message != 'undefined') {
                    collection_eta_message = translation_obj.trans_collection_eta_message
                }
            }
        }
    }


    if (app_enable == 0 || collection_page_eta_enable == 0) {

    } else {
        if (add_ETA_on_collection_page == 1) {
            showETAonCollectionpage()
        }
    }

    function getCollectionsForProductForCollection(productId) {
        if (!window.CollectionMapping) return [];
        const collections = window.CollectionMapping[String(productId)] || [];
        return collections;
    }

    function getProductQunaity(productId) {
        if (!window.collectionPageProductQuantity) return [];
        const collectionPageProductQuantity = window.collectionPageProductQuantity[String(productId)];
        return collectionPageProductQuantity;
    }

    function getProductAvailability(productId) {
        if (!window.collectionPageProductAvailability) return [];
        const collectionPageProductAvailability = window.collectionPageProductAvailability[String(productId)];
        return collectionPageProductAvailability;
    }

    function showETAonCollectionpage() {

        $('body').append('<style>.installments:not(:has(shopify-payment-terms)),.product-grid-view-zoom-out--details {display: block !important;}</style>')
        if ($(".eta_custom_position").length > 0) {

            $(".eta_custom_position").each(function () {
                if (!$(this).hasClass('cfp-checked')) {
                    var curr_this = $(this);
                    var product_handle = $(this).attr('product_handle');
                    var product_url = "/products/" + product_handle;
                    try {
                        fetch(product_url + ".json", {
                            credentials: "same-origin"
                        }).then(function (data) {
                            data.json().then(function (data) {
                                var get_product = data.product;
                                var cfp_product_on = true;
                                //Check EDD product here
                                if (cfp_product_on) {
                                    var current_object = '';
                                    current_object = appendCFPButtonCollection(curr_this);
                                    // var cfpButtonCollection =
                                    // '<div class="eta-prod-wrapper ' + get_product.handle + '" >' +
                                    // '<div class="eta-prod-button-call">' +
                                    // '<a class="cfp_call_button" target="_parent" ><button type="button" class="btn Button Button--primary button btn-primary button--primary"><svg width="24" height="24" class="feather-phone-call" xmlns="http://www.w3.org/2000/svg"><path d="M8.26 1.289l-1.564.772c-5.793 3.02 2.798 20.944 9.31 20.944.46 0 .904-.094 1.317-.284l1.542-.755-2.898-5.594-1.54.754c-.181.087-.384.134-.597.134-2.561 0-6.841-8.204-4.241-9.596l1.546-.763-2.875-5.612zm7.746 22.711c-5.68 0-12.221-11.114-12.221-17.832 0-2.419.833-4.146 2.457-4.992l2.382-1.176 3.857 7.347-2.437 1.201c-1.439.772 2.409 8.424 3.956 7.68l2.399-1.179 3.816 7.36s-2.36 1.162-2.476 1.215c-.547.251-1.129.376-1.733.376"/></svg>Request a Quote</button></a>' +
                                    // '</div>' +
                                    // '</div>';
                                    eta_message = callVariantWiseInventoryMessage(get_product)

                                    
                                    if (current_object != '') {
                                        if (!$(curr_this).hasClass(cfpCollectionLabelClass)) {
                                            if ($('.eta-prod-wrapper.' + get_product.handle).length > 0 || current_object.parent().parent().parent().find('.eta-prod-wrapper-detail').length > 0) {
                                                if ($('.eta-prod-wrapper.' + get_product.handle).parent().parent().parent().find('.eta-prod-wrapper.' + get_product.handle).length > 0 || current_object.parent().parent().parent().find('.eta-prod-wrapper-detail').length > 0) {
                                                    $(".eta_custom_position." + product_handle).html(eta_message);
                                                } else {
                                                    $(".eta_custom_position." + product_handle).html(eta_message);
                                                }
                                            } else {
                                                $(".eta_custom_position." + product_handle).html(eta_message);
                                            }
                                            $(curr_this).addClass(cfpCollectionLabelClass);
    
                                            $('.add_hidden_delivery').val(getCartDate)
                                        }
                                    }
                                }
                            })
                        })
                    } catch (e) { }
                }
            })
        } else {
            $("a").each(function () {
                var curr_this = $(this);
                var curr_href = curr_this.attr("href");
                var imgg = $(curr_this).closest('div').find('img').first();
                if (typeof curr_href !== 'undefined') {
                    if (curr_href.indexOf("products/") >= 1 && $(this).parent().get(0).tagName != 'LI' && !$(this).hasClass('doNotAdd_ETA')) {
                        curr_href = curr_href.split("?")[0];
                        fetch(curr_href + ".json", {
                            credentials: "same-origin"
                        }).then(function (data) {
                            data.json().then(function (data) {
                                var get_product = data.product;
                                var cfp_product_on = true; //CHeck EDD product here
                                if (cfp_product_on) {
                                    var current_object = '';
                                    if ($(curr_this).find('img').first().length > 0) {
                                        if (!$(curr_this).find('img').first().hasClass(cfpCollectionLabelClass)) {
                                            current_object = appendCFPButtonCollection(curr_this);
                                            $(curr_this).find('img').first().addClass(cfpCollectionLabelClass);
                                        }
                                    } else if ($(curr_this).closest('div').find('img').first().length > 0) {
                                        if (!$(curr_this).closest('div').find('img').first().hasClass(cfpCollectionLabelClass)) {
                                            current_object = appendCFPButtonCollection(curr_this);
                                            $(curr_this).closest('div').find('img').first().addClass(cfpCollectionLabelClass);
                                        }
                                    } else if ($(curr_this).closest('div').parent().find('img').first().length > 0) {
                                        if (!$(curr_this).closest('div').parent().find('img').first().hasClass(cfpCollectionLabelClass)) {
                                            current_object = appendCFPButtonCollection(curr_this);
                                            $(curr_this).closest('div').parent().find('img').first().addClass(cfpCollectionLabelClass);
                                        }
                                    }
                                    else if ($(curr_this).closest('div').parent().parent().find('img').first().length > 0) {
                                        if (!$(curr_this).closest('div').parent().parent().find('img').first().hasClass(cfpCollectionLabelClass)) {
                                            current_object = appendCFPButtonCollection(curr_this)
                                            $(curr_this).closest('div').parent().parent().find('img').first().addClass(cfpCollectionLabelClass);
                                        }
                                    } else if ($(curr_this).closest('div').parent().parent().parent().find('img').first().length > 0) {
                                        if (!$(curr_this).closest('div').parent().parent().parent().find('img').first().hasClass(cfpCollectionLabelClass)) {
                                            current_object = appendCFPButtonCollection(curr_this)
                                            $(curr_this).closest('div').parent().parent().parent().find('img').first().addClass(cfpCollectionLabelClass);
                                        }
                                    } else if ($(curr_this).closest('div').parent().parent().parent().parent().find('img').first().length > 0) {
                                        if (!$(curr_this).closest('div').parent().parent().parent().parent().find('img').first().hasClass(cfpCollectionLabelClass)) {
                                            current_object = appendCFPButtonCollection(curr_this)
                                            $(curr_this).closest('div').parent().parent().parent().parent().find('img').first().addClass(cfpCollectionLabelClass);
                                        }
                                    } else if ($(curr_this).closest('div').parent().parent().parent().parent().parent().find('img').first().length > 0) {
                                        if (!$(curr_this).closest('div').parent().parent().parent().parent().parent().find('img').first().hasClass(cfpCollectionLabelClass)) {
                                            current_object = appendCFPButtonCollection(curr_this)
                                            $(curr_this).closest('div').parent().parent().parent().parent().parent().find('img').first().addClass(cfpCollectionLabelClass);
                                        }
                                    }
                                    // eta_message =  callVariantWiseInventoryMessage(get_product)
                                    // var cfpButtonCollection =
                                    // '<div class="eta-prod-wrapper ' + get_product.handle + '">' +
                                    // '<div class="eta-prod-button-call">' +
                                    //  eta_message
                                    // '</div>' +
                                    // '</div>';
                                    if (current_object != '') {
                                        if (!$(curr_this).hasClass(cfpCollectionLabelClass)) {
                                            $(curr_this).addClass(cfpCollectionLabelClass);
                                            if ($('.eta-prod-wrapper.' + get_product.handle).length > 0 || current_object.parent().parent().parent().find('.eta-prod-wrapper-detail').length > 0 || current_object.parent().parent().parent().find('.eta-prod-wrapper-detail-call').length > 0) {
                                                if ($('.eta-prod-wrapper.' + get_product.handle).parent().parent().parent().find('.eta-prod-wrapper.' + get_product.handle).length > 0 || current_object.parent().parent().parent().find('.eta-prod-wrapper-detail').length > 0 || current_object.parent().parent().parent().find('.eta-prod-wrapper-detail-call').length > 0) {
                                                } else {
                                                    eta_message = callVariantWiseInventoryMessage(get_product)
                                                    current_object.after(eta_message);
                                                }
                                                //$('.eta-prod-wrapper.'+get_product.handle)[1].remove();
                                            } else {
                                                eta_message = callVariantWiseInventoryMessage(get_product)
                                               
                                                current_object.after(eta_message);
                                            }
                                        }
                                    }
                                }
                            })
                        })
                    };
                }
            })
        }
    }

    function callVariantWiseInventoryMessage(get_product) {
        sb_variant_title = get_product.title;
        sb_variant_id = get_product.id;
        sb_variant_handle = get_product.handle;
        curr_selected_variant_title = 'not_set';
        if (shopnamefull == 'ninetwofive-nl.myshopify.com') {
            var curr_selected_variant_title = $("form .sb_variant_option").find(":selected").text();
        }

        //sb_location_with_qty = variant_with_warehouse_qty[sb_variant_id]
        sb_set_specific_msg = '0';
        sb_is_set_msg_for_product = "0";
        is_set_msg_for_product_type = "0";
        is_set_msg_for_sb_product_tag = "0";
        is_set_msg_for_sb_product_vendor = "0";
        is_set_msg_for_sb_all_product = "0";
        is_set_msg_for_sb_collection = "0";
        sb_edd_message = 'not_set';
        sb_is_exclude_product = 0;
        specific_weekoff = 'not_set'
        specific_holiday = 'not_set'
        specific_delivery_weekoff = 'not_set'
        specific_date_format = 'not_set';
        specific_date_option = 'not_set';
        specific_custom_date_format = 'not_set';
        specific_cutofftime = 'not_set';
        specific_cutofftime_enable = 'not_set';

        hide_default_message = sb_edd_options.hide_default_message
        message = 'not_set';


        edd_options = sb_edd_options
        every_year_holidays = [];
        holidays = [];
        get_shortcode_with_value_with_en_lag = [];
        get_shortcode_with_value_with_store_lag = [];

        edd_sb_product_id = sb_variant_id.toString();
        edd_sb_product_vendor = get_product.vendor;
        check_product_tag = get_product.tags;
        if (check_product_tag.replaceAll(' ', '').length > 0) {
            check_product_tag = check_product_tag.replaceAll(', ', ',')
            check_product_tag = check_product_tag.split(',');
        } else {
            check_product_tag = ''
        }
        edd_sb_product_tag = check_product_tag
        edd_sb_collection_id = getCollectionsForProductForCollection(get_product.id);

        edd_sb_product_qty = getProductQunaity(get_product.id);

        sb_product_avaiable = getProductAvailability(get_product.id);


        if (sb_edd_options.is_enabled == '0' || sb_edd_shipping_enable != '0' || sb_edd_location_enable != '0' || sb_edd_location_enable != '0' || sb_edd_zipcode_enable == 1 || sb_is_exclude_product == '1' || is_country_dropdown_on == 'true') {
            if (shopnamefull != 'ninetwofive-nl.myshopify.com') {
                return false
            }
        }

        //if(variant_qty == 0){
       // $('.deliverydate.sb_delivery,.add_hidden_delivery').remove();
        // }else{
        instock_based_on_avalibility = 0;

        if (typeof sb_edd_options.instock_based_on_avalibility != 'undefined') {
            instock_based_on_avalibility = sb_edd_options.instock_based_on_avalibility;
        }

        instock_based_on_continue_selling = '0';
        if (typeof sb_edd_options.instock_based_on_continue_selling != 'undefined') {
            instock_based_on_continue_selling = sb_edd_options.instock_based_on_continue_selling;
        }


        if (instock_based_on_continue_selling == '1') {
            if (sb_product_avaiable == 'true') { sb_product_have_qty = 1; }
        } else {
            if (instock_based_on_avalibility == 1 || edd_store_id > 2614 || edd_shop == 'kitchen-king-uk.myshopify.com' || edd_shop == 'diecaststoreuk.myshopify.com' || edd_shop == 'purrfetto.myshopify.com' || edd_shop == 'estimated-delivery-date-time.myshopify.com') {
                if (edd_sb_product_qty > 0) {
                    sb_product_have_qty = 1;
                } else if (edd_sb_product_qty <= 0 && sb_product_avaiable == false) {
                    /* set ETA rule comptible with out of stock product & dont have qty */
                    sb_product_have_qty = 3;
                } else if (edd_sb_product_qty <= 0 && sb_product_avaiable == true) {
                    /* set ETA rule comptible with out of stock product & dont have qty */
                    sb_product_have_qty = 0;
                }
                /* set ETA rule comptible with out of stock product & dont have qty */
            } else {
                if (sb_product_avaiable == 'true') { sb_product_have_qty = 1; }
            }
        }


        // product_have_qty = variant_qty;


        //if($(".deliverydate.sb_delivery .delivery_msg").length == 0){

        findSpecificEDDMsg();

        if (sb_set_specific_msg == 0) {
            sb_product_have_qty = 2;
            findSpecificEDDMsg();
        }


        if (typeof sb_edd_preview_design !== 'undefined' && sb_edd_preview_design != 'not_set' && sb_set_specific_msg == '1') {
            specific_preview_design = sb_edd_preview_design
        }

        if (typeof sb_edd_message !== 'undefined' && sb_edd_message != 'not_set') {
            message = sb_edd_message
        } else {
            if(typeof hide_default_message == 'undefined'){
                hide_default_message = 0 
            }
            if (hide_default_message == 0) {
                message = sb_edd_options.message;
            }
        }
        if (sb_is_exclude_product == 1) {
            message = 'not_set';
        }


        /* holidays */
        if (typeof sb_edd_options.holidays != 'undefined') {
            holidays_object = JSON.parse(sb_edd_options.holidays);
            $.each(holidays_object, function (key, sb_edd_obj) {
                holidays.push(sb_edd_obj.holiday)
                if (sb_edd_obj.every_year == 'Yes') {
                    new_date = new Date(sb_edd_obj.holiday);

                    month = new_date.getMonth() + 1; // like 5
                    month = (('' + month).length < 2 ? '0' : '') + month; // like 05
                    todate = new_date.getDate();
                    todate = (('' + todate).length < 2 ? '0' : '') + todate;
                    check_holidays = month + '-' + todate;
                    every_year_holidays.push(check_holidays)
                }
            })
        }
        /* holidays */

        /* specific ETA rule holiday */
        if (typeof specific_holiday != 'undefined') {
            if (specific_holiday != 'not_set') {
                every_year_holidays = [];
                holidays = [];
                holidays_object = specific_holiday;
                $.each(holidays_object, function (key, sb_edd_obj) {
                    holidays.push(sb_edd_obj.holiday)
                    if (sb_edd_obj.every_year == 'Yes') {
                        new_date = new Date(sb_edd_obj.holiday);

                        month = new_date.getMonth() + 1; // like 5
                        month = (('' + month).length < 2 ? '0' : '') + month; // like 05
                        todate = new_date.getDate();
                        todate = (('' + todate).length < 2 ? '0' : '') + todate;
                        check_holidays = month + '-' + todate;
                        every_year_holidays.push(check_holidays)
                    }
                })
            }
        }
        /* specific ETA rule holiday */

        /* apply delivery weekoff day */
        off_day = sb_edd_options.off_day;
        if (specific_weekoff != 'not_set') {
            off_day = specific_weekoff;
        }
        if (typeof sb_edd_options.delivery_off_day != 'undefined' && sb_edd_options.delivery_off_day != 'not_set') {
            delivery_off_day = sb_edd_options.delivery_off_day;
        } else {
            delivery_off_day = sb_edd_options.off_day;
            if (specific_weekoff != 'not_set') {
                delivery_off_day = specific_weekoff;
            }
        }
        if (specific_delivery_weekoff != 'not_set') {
            delivery_off_day = specific_delivery_weekoff
        }

        /* apply delivery weekoff day */
        date_option = 'default'
        /* custom date, date options, countdown timer */
        if (typeof sb_edd_options.date_option != 'undefined') {
            date_option = sb_edd_options.date_option;
        }
        if (typeof sb_edd_options.date_format != 'undefined') {
            date_format = sb_edd_options.date_format;
        }
        custom_date_format = 'not_set';
        if (typeof sb_edd_options.custom_date_format != 'undefined') {
            custom_date_format = sb_edd_options.custom_date_format
        }
        if (typeof sb_edd_options.countdown_formate != 'undefined') {
            countdownFormate = sb_edd_options.countdown_formate
        }
        /* apply specific message date formate */
        if (typeof specific_date_option != 'undefined' && sb_set_specific_msg == '1') {
            if (specific_date_option != 'not_set') { date_option = specific_date_option; }
        }
        if (typeof specific_date_format != 'undefined' && sb_set_specific_msg == '1') {
            if (specific_date_format != 'not_set') { date_format = specific_date_format }
        }
        if (typeof date_option != 'undefined' && sb_set_specific_msg == '1') {
            if (date_option == 'custom' && typeof specific_custom_date_format != 'undefined') {
                if (specific_custom_date_format != '' && specific_custom_date_format != 'not_set') {
                    custom_date_format = specific_custom_date_format
                }
            }
        }

        if (typeof specific_countdown_option != 'undefined') {
            if (specific_countdown_option != 'not_set') { countdownFormate = specific_countdown_option }
        }
        /* apply specific message date formate */
        custom_date_format = custom_date_format.replaceAll('  ', ' ')
        check_custom_date_format_length = custom_date_format.replaceAll(' ', '')

        if (custom_date_format != '' && date_option == 'custom' && check_custom_date_format_length != 0) {
            get_custom_date_format = 'get';
        }
        /* custom date, date options, countdown timer */

        /* cutoff time */

        edd_cart_min_day = '';
        edd_cart_max_day = '';


        getStoreDate = $('.sb_store_date').text()

        todayDate = new Date(getStoreDate);
        storeTodayDate = new Date(getStoreDate);
        storeTodayDate = getCurrentDateOfStoreAndUser(storeTodayDate);
        cutoff_time = sb_edd_options.cutoff_time
        if (typeof specific_cutofftime != 'undefined' && specific_cutofftime != 'not_set') {
            cutoff_time = specific_cutofftime;
        }
        cutofftime_enable = sb_edd_options.cutofftime_enable
        if (typeof specific_cutofftime_enable != 'undefined' && specific_cutofftime_enable != 'not_set') {
            cutofftime_enable = specific_cutofftime_enable
        }
        cutoff_time = cutoff_time.replace(' : ', ':')
        storeTodayDate = storeTodayDate.current_date + ' ' + cutoff_time;
        store_full_dateTime = storeTodayDate
        
        if (cutofftime_enable == 1) {
            if (todayDate < new Date(store_full_dateTime)) {
                check_cutoff = 'more';
            } else {
                check_cutoff = 'less';
            }
        } else {
            check_cutoff = 'disabled';
        }
        /* cutoff time */





        if ((message != 'not_set' && typeof hide_default_message != 'undefined' && hide_default_message == 0) || sb_edd_message != 'not_set') {
            variantWiseInstockOutofstockMsgFromEDDScript($);
        } else {
            //$('.deliverydate.sb_delivery,.add_hidden_delivery').remove();
        }

        var etaMesageOnCollectionMsg = '';
        if (message != 'not_set') {

            let ETA_dates = {
                delivery_min_date: edd_cart_min_day,
                delivery_max_date: edd_cart_max_day.replace('-', '')
            };

            let ETA_for_collection = renderEtaMessage(collection_eta_message, ETA_dates);
            // etaMesageOnCollectionMsg =
            //     '<div class="eta-prod-wrapper ' + get_product.handle + '">' +
            //     '<div class="eta-prod-button-call">' + message + '----------<br/>' +
            //     ETA_for_collection + "<br/><div style='font-size:12px'>" + ' cutoff_time : ' + cutoff_time + ' ' + check_cutoff + "<br/>" +
            //     ' date_option : ' + date_option + ' date_format : ' + date_format + ' custom_date_format : ' + custom_date_format
            //     + "<br/>" + ' countdownFormate : ' + countdownFormate + "<br/>" +
            //     ' delivery_off_day :' + delivery_off_day + ' off_day : ' + off_day + "<br/>" + ' holidays ' + holidays + 'collection_eta_message </div>' +
            //     '</div>' +
            //     '</div>';
             etaMesageOnCollectionMsg =
                '<div class="eta-prod-wrapper ' + get_product.handle + '">' +
                '<div class="eta-prod-button-call">' +
                ETA_for_collection + '</div>' +
                '</div>';
        }

        return etaMesageOnCollectionMsg;

        addEstimatedMessageClass($);
        if (sb_edd_options.display_on_other_page == '1') {
            displayOnCartPage($);
        }

        //}

        // ninetwofive-nl.myshopify.com custom variant out stock condition
        // if(shopnamefull == 'ninetwofive-nl.myshopify.com'){
        //   if(typeof edd_multiple_rule_for_shipping != 'undefined'){
        //     var selected_shipment_method = $(".selected_shipping_span").text();
        //     sb_edd_message = edd_multiple_rule_for_shipping[selected_shipment_method].message;
        //     sb_edd_message = getLanguageWiseMsg(edd_multiple_rule_for_shipping[selected_shipment_method], sb_edd_message);
        //     sb_edd_preview_design = edd_multiple_rule_for_shipping[selected_shipment_method].preview_design;
        //   }
        //   myAppcallForMessage($);
        // }
        // ninetwofive-nl.myshopify.com custom variant out stock condition

        //}

    }

    function renderEtaMessage(temp_message, values) {
        var rxp = /{([^}]+)}/g;
        return temp_message.replace(rxp, (match, key) => {
            let normalizedKey = key.trim().toLowerCase();

            if (normalizedKey == "delivery_min_date") {
                return values.delivery_min_date || "";
            }
            if (normalizedKey == "delivery_max_date") {
                return values.delivery_max_date || "";
            }

            return match;
        });
    }

    function getCurrentDateOfStoreAndUser(todayDate) {

        var format = "AM";
        var hour = todayDate.getHours();
        var min = todayDate.getMinutes();
        if (hour > 11) { format = "PM"; }
        if (hour > 12) { hour = hour - 12; }
        if (hour == 0) { hour = 12; }
        if (min < 10) { min = "0" + min; }

        current_date = todayDate.getMonth() + 1 + "/" + todayDate.getDate() + "/" + todayDate.getFullYear();
        current_time = hour + ":" + min + " " + format;
        return { current_date: current_date, current_time: current_time };
    }

    function appendCFPButtonCollection(curr_this) {
        var cfpProductPrice = 'price';
        var cfpProductMoney = 'money';
        var current_object = '';
        var isTitleFound = false;
        // if (typeof (doNotHidePrice) !== 'undefined') { isTitleFound = true; current_object = curr_this.find('test'); }
        if (!isTitleFound) {
            var divFind = $(curr_this).closest('div').find('div,h3,h2,a,span,ul,dl');
            current_object = searchCFPprice(divFind);
            if (current_object != '') { isTitleFound = true; }
        }
        if (!isTitleFound) {
            var divFind = $(curr_this).closest('div').parent().find('div,h3,h2,a,span,ul,dl');
            current_object = searchCFPprice(divFind);
            if (current_object != '') { isTitleFound = true; }
        }
        if (!isTitleFound) {
            var divFind = $(curr_this).closest('div').parent().parent().find('div,span,ul,dl');
            current_object = searchCFPprice(divFind);
            if (current_object != '') { isTitleFound = true; }
        }
        if (!isTitleFound) {
            var divFind = $(curr_this).closest('div').parent().parent().find('a,h2,h3,h4,h1,span,ul,dl');
            current_object = searchCFPprice(divFind);
            if (current_object != '') { isTitleFound = true; }
        }
        if (!isTitleFound) {
            var divFind = $(curr_this).closest('div').parent().parent().parent().find('div,h2,h3,a,span,ul,dl');
            current_object = searchCFPprice(divFind);
            if (current_object != '') { isTitleFound = true; }
        }
        if (!isTitleFound) {
            var divFind = $(curr_this).closest('div').parent().parent().parent().parent().find('div,h2,h3,a,span,ul,dl');
            current_object = searchCFPprice(divFind);
            if (current_object != '') { isTitleFound = true; }
        }
        if (!isTitleFound) {
            var divFind = $(curr_this).closest('div').parent().parent().parent().parent().parent().find('div,h2,h3,a,span,ul,dl');
            current_object = searchCFPprice(divFind);
            if (current_object != '') { isTitleFound = true; }
        }
        return current_object;
    }
    function searchCFPprice(divFind) {
        var cfpProductPrice = 'price';
        var cfpProductMoney = 'money';
        var current_object = '';
        $(divFind).each(function (i) {
            var class_title = $(this).attr('class');
            if (typeof (class_title) != 'undefined') {
                if ((class_title.includes(cfpProductPrice) || class_title.includes(cfpProductMoney)) && (!class_title.includes("sb-not-price"))) {
                    current_object = $(this)
                    // $(this).hide(); // return current_object;
                    return false;
                }
            }
        });
        return current_object;
    }
}